export function getStatus(treatment_id, treatments) {
  let treatment = treatments.find(i => i._id === treatment_id)
  return treatment?.status_name ?? ''
}
